module.exports = __webpack_public_path__ + "img/IMG_9928_L_Wood_MockedUp.4a42f331.jpg";